import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useConfig } from 'Context/ConfigContext';
import { useAllMyCoursesData, MY_COURSES_MODE } from 'Domain/MyCourseData';
import { sortCoursesByDate } from 'Util/course';

import { CourseList } from '../../Components/CourseBanner/CourseBanner';

const RecentCourses = (props) => {
  const history = useHistory();
  const { t } = useTranslation('myCourses');
  const { data: courses } = useAllMyCoursesData({ mode: MY_COURSES_MODE.ALL });
  const { uiVariant, myCourses, eBookCourseRegex = /^.*E$/ } = useConfig();
  const maxRecentCoursesCount = myCourses?.maxRecentCoursesCount ?? 5;

  const sortedCourses = sortCoursesByDate(
    courses,
    `courseInfo.classroomProgress.lastEnterAt`,
    true
  );

  return (
    <CourseList
      courses={sortedCourses.slice(0, maxRecentCoursesCount)}
      onCourseCardClick={(courseId) => history.push(`classroom/${courseId}`)}
      t={t}
      variant={uiVariant}
      eBookCourseRegex={eBookCourseRegex}
      {...props}
    />
  );
};

export default RecentCourses;
